import React from 'react';

import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {getUserProperties} from 'static/three-oh/src/modules/selectors/userSelectors';

import {
  licenseContainer,
  productListContainer,
  productList,
  sectionLabel,
  trialDays,
} from './style.jsx';


const propTypes = {
  licenses: PropTypes.array,
  licensed_collections: PropTypes.array,
  getDaysLeftInTrial: PropTypes.func,
};

const LicenseList = (props) => {
  const licenseByStatus = {
    is_subscription: [],
    is_trial: [],
    free: [],
  };
  const licenseNameMap = {
    ela: 'Newsela ELA',
    science: 'Newsela Science',
    social_studies: 'Newsela Social Studies',
    essentials: 'Newsela Essentials',
    power_words: 'Power Words',
    teacher_learning_hub: 'PD Pass',
    collections: 'Collections'
  };
    // TODO: potentially use subscriptionProducts for district admins to dedupe between trial and subscription links
    // or show district admins something totally different as this feature might not make sense for them.
  const licenses = props.licenses ? props.licenses : useSelector((state) => state?.user?.licenses);

  licenses.map((license) => {
    // Exclude free products from this display.
    // Check that the license is active.
    if (license.is_active) {
      if (license.is_subscription) {
        licenseByStatus.is_subscription.push(license);
      }
      if (license.is_trial) {
        licenseByStatus.is_trial.push(license);
      }
    }
  });


  // dedupe trials and subscriptions
  const isSubscriptionUnique = [...new Set(licenseByStatus.is_subscription.map((item) => item.product))];
  const isTrialUnique = [...new Set(licenseByStatus.is_trial.map((item) => item.product))];

  // TODO: eventually we will be trialing collections
  const daysLeftInTrial = props.getDaysLeftInTrial ? props.getDaysLeftInTrial(licenseByStatus.is_trial[0])
    : useSelector((state) => getUserProperties(state).getDaysLeftInTrial(licenseByStatus.is_trial[0]));
  return (
    <div className={productListContainer}>
      {
          licenseByStatus.is_trial.length ?
            <div className={productList}>
              <div className={licenseContainer}>
                <div className={sectionLabel}>Trial Product(s)</div>
                {
                  daysLeftInTrial && daysLeftInTrial < 90 ?
                    <div className={trialDays}>{daysLeftInTrial} days left</div> :
                    null
                }
              </div>
              <ul>
                {
                  isTrialUnique.map((license) => {
                    return (<li key={license}>{licenseNameMap[license]}</li>);
                  })
                }
              </ul>
            </div> :
            null
        }
      {
          licenseByStatus.is_subscription.length ?
            <div className={productList}>
              <div className={licenseContainer}>
                <div className={sectionLabel}>
                  Subscription Product(s)
                </div>
              </div>
              <ul>
                {
                  isSubscriptionUnique.map((license) => {
                    return (<li key={license}>{licenseNameMap[license]}</li>);
                  })
                }
              </ul>
            </div> :
            null
        }
    </div>
  );
};

LicenseList.propTypes = propTypes;
export default LicenseList;
